import { render } from "./InputTypeMultiSelect.vue?vue&type=template&id=0f8085c0"
import script from "./InputTypeMultiSelect.vue?vue&type=script&lang=js"
export * from "./InputTypeMultiSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__